import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import {
  EstimateFeeReq,
  EstimateFeeRes,
  WithdrawalReq,
  WithdrawalRes,
} from '../entities';

export interface WithdrawalApi {
  withdrawal(params: WithdrawalReq): Observable<WithdrawalRes>;
  estimateFee(params: EstimateFeeReq): Observable<EstimateFeeRes>;
}

export const WITHDRAWAL_API = new InjectionToken<WithdrawalApi>(
  'WITHDRAWAL_API',
);
